import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import InfoTrx from "./infoTrx";
import "./style.scss";
import MobileHeader from "../../../components/Header/MobileHeader";
import PrincipalLogo from "../../../assets/images/principal.png";
import { Typography, Button, Box } from "@mui/material";
import styles from "./styles";
import { text } from "../../../utils/styles/style";
import {
  getPaymentStatus,
  postToChannel,
  setupErrPaymentPay
} from "../redux/action";

function FailedScreenPaymentPay(props) {
  const {
    custData,
    paymentStatus = { status: 1, payRefNo: "" },
    getPaymentStatus,
    postToChannel,
    trxRefNumber,
    onDone,
    setupErrPaymentPay,
    loadingScreenFailedForPaymentsPay
  } = props;

  const [totalStatus, setotalStatus] = useState(0);

  useEffect(() => {
    getPaymentStatus(trxRefNumber);
  }, []);

  useEffect(() => {
    setotalStatus(paymentStatus.total + paymentStatus.fee);
  }, [paymentStatus.fee]);

  const handleGA = () => {
    if (paymentStatus.status === "5") {
      window.dataLayer.push({
        event: "click_tag",
        action: "Click",
        category: "Button",
        label: `Cash In Success Done ${paymentStatus.customerChannelCode}`
      });
    } else {
      window.dataLayer.push({
        event: "click_tag",
        action: "Click",
        category: "Button",
        label: `Cash In Failed Done ${paymentStatus.customerChannelCode}`
      });
    }
  };

  const ActiveLink = ({ content, link = false }) => {
    return (
      <a
        onClick={e => {
          if (custData.customerChannelCode === "Mini Program" && window.my) {
            e.preventDefault();
            window.my.navigateTo({
              url:
                "/pages/link/link?url=" +
                encodeURIComponent("https://www.principal.com.my/en/contact-us")
            });
          }
        }}
        href={link}
        className="active-link"
        target={link ? "_blank" : "_self"}
        rel="noopener noreferrer"
      >
        {content}
      </a>
    );
  };
  return (
    <>
      <Box sx={styles.App}>
        <MobileHeader title="Principal Payment Gateway" />
        {loadingScreenFailedForPaymentsPay ? (
          <Box sx={styles.centered} style={{ flex: 1 }}>
            <img
              src={PrincipalLogo}
              alt="Principal"
              style={{
                maxWidth: "40%",
                marginBottom: "16px",
                width: 124.7,
                height: 40
              }}
            />
            <Typography sx={styles.title}>Please Wait ...</Typography>
            <p />
            <Typography sx={styles.titleCenter}>
              We are processing your Cash In
            </Typography>
          </Box>
        ) : (
          <>
            <div style={{ padding: "0 2rem", marginTop: 16 }}>
              <img
                src={PrincipalLogo}
                alt="Principal"
                style={{
                  maxWidth: "40%",
                  marginBottom: "16px",
                  width: 124.7,
                  height: 40
                }}
              />

              <Typography
                style={{ marginBottom: 20 }}
                sx={styles.titleFailed}
              >
                {"Cash In failed"}
              </Typography>
              <Typography
                style={{
                  wordSpacing: "2px",
                  fontSize: "16px",
                  color: text.color.greyText,
                  fontFamily: "FS-Elliot, sans-serif"
                }}
                component="p"
              >
                Sorry, we were unable to process the Cash In. Please try again
                or contact our
                <ActiveLink
                  link="https://www.principal.com.my/en/contact-us"
                  content=" customer support"
                >
                  customer support.
                </ActiveLink>
              </Typography>
            </div>
            <InfoTrx
              custData={custData}
              paymentStatus={paymentStatus}
              totalStatus={totalStatus.toFixed(2)}
            />
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0 20px",
                  marginTop: 24
                }}
                className="SubmitButton"
              >
                <Button
                  onClick={() => {
                    postToChannel({
                      ...paymentStatus,
                      resUrl: paymentStatus.resUrl || custData.resUrl
                    });
                    handleGA();
                    setupErrPaymentPay(false);
                    onDone();
                  }}
                  variant="contained"
                  color="secondary"
                  className="next-button"
                  fullWidth
                  style={{ marginBottom: 24 }}
                >
                  Done
                </Button>
              </div>
            </div>
          </>
        )}
      </Box>
    </>
  );
}

const withConnect = connect(
  state => ({
    ...state.FPXReducer
  }),
  { getPaymentStatus, postToChannel, setupErrPaymentPay }
);

export default compose(
  withRouter,
  withConnect
)(FailedScreenPaymentPay);
